// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1f6Pd","info":"UpdateTermsInfo_info__2cmAf"};